class ProductTools extends lm.Composant {
  constructor(id) {
    super(id);
  }
}
lm.DOMReady(function () {
  new ProductTools("producttools");
});
export default ProductTools;